import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AddCandidate } from 'src/app/public/app/models/addCandidate';
import { StorageService } from 'src/app/core/services/storage.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { JobService } from 'src/app/core/services/job.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ResumeService } from 'src/app/core/services/resume.service';

declare var bootbox: any;

@Component({
  selector: 'app-add-candidates',
  templateUrl: './add-candidates.component.html'
})
export class AddCandidatesComponent implements OnInit {

  @Input() jobId;
  @Input() isSharedJob;
  @Input() onlyUploadResume;
  @Input() singleUploadResume;
  @Input() candidateId;
  @Input() corporateId;
  @Input() clientOrBuId;
  @Input() context;
  @Input() sourceScreen;
  @Input() formalizeActivityPayload;
  @Input() sourceTypeList: any[] = [];
  @Input() disableSourceTypesFlag = false;
  @Output() saveCallback = new EventEmitter<void>();
  @Output() candidateProcessedCallback = new EventEmitter<void>();

  @ViewChildren('addForm') addForms!: QueryList<NgForm>;

  currentCompanyId: any;
  userId: any;

  loadingResumeOptions = true;
  showResumeOptions = false;
  isAddCandidateForCorp = false;
  candidatesArray: any[] = [];
  savingFlag = false;
  controlObject: any = {};
  addWithResumesFlag = true;
  sendOutreachEmail = false;
  isOutreachEnabled = false;

  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    private candidateService: CandidateService,
    private jobService: JobService,
    private companyService: CompanyService,
    private angularModalService: AngularModalService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private resumeService: ResumeService
  ) { }

  ngOnInit() {
    this.currentCompanyId = this.authService.userDetails.company.companyId;
    this.userId = this.authService.userDetails.id;

    this.loadingResumeOptions = true;
    this.showResumeOptions = false;
    this.isAddCandidateForCorp = false;
    this.candidatesArray = [];
    this.savingFlag = false;
    this.controlObject = {};
    this.controlObject.disableCancelButtonFlag = false;
    this.addWithResumesFlag = true;
    this.sendOutreachEmail = false;
    this.isOutreachEnabled = false;
    this.isAddCandidateForCorp = this.companyService.isCorporateCompany() || (this.corporateId !== undefined && this.corporateId !== '');
    this._setResumeOptions();
    this._checkIfOutreachEnabled();
  }

  private _setResumeOptions() {
    let companyIdToCheckAUploadResumeAccess;
    if (this.isAddCandidateForCorp || (this.jobId == undefined || this.jobId === null || this.jobId == '')) {
      this.clientOrBuId = null;
    }
    if (this.corporateId !== undefined && this.corporateId !== '') {
      companyIdToCheckAUploadResumeAccess = this.corporateId;
    } else {
      companyIdToCheckAUploadResumeAccess = this.currentCompanyId;
    }

    if (this.onlyUploadResume) {
      this.showResumeOptions = false;
      this.loadingResumeOptions = false;
    } else if ((this.isSharedJob && this.corporateId !== undefined && this.corporateId !== '') || (!this.isAddCandidateForCorp)) {
      this.companyService.hasAccessToUploadResume(companyIdToCheckAUploadResumeAccess, this.clientOrBuId, (data) => {
        this.showResumeOptions = !data;
        this.addAnotherCandidate();
        if (this.showResumeOptions) {
          this._setDefaultCandidateAddOption();
        } else {
          this.loadingResumeOptions = false;
        }
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else {
      this.addAnotherCandidate();
      this.showResumeOptions = true;
      this._setDefaultCandidateAddOption();
    }
  }

  private _checkIfOutreachEnabled() {
    this.isOutreachEnabled = true;
  }

  private _setDefaultCandidateAddOption() {
    if (this._isAddCandidateToJob()) {
      this.jobService.getLastCandidateAddOption(this.jobId, (data) => {
        this.addWithResumesFlag = data['lastAddCandidateOption'] != 'Without Resume';
        this.loadingResumeOptions = false;
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else {
      this.loadingResumeOptions = false;
    }
  }

  private _isAddCandidateToJob() {
    return this.jobId !== undefined;
  }

  onAddCandidateOptionChange() {
    this.storageService.set('addCandidateWithResumeEnabled', this.addWithResumesFlag, null);
  }

  addAnotherCandidate() {
    const addCandidate: any = new AddCandidate();
    addCandidate.jobId = this.jobId;
    addCandidate.companyId = this.currentCompanyId;
    addCandidate.addStatus = 'add';
    addCandidate.errorMessages = [];
    this.candidatesArray.push(addCandidate);
  }

  removeCandidate(index) {
    this.candidatesArray.splice(index, 1);
  }

  cancel() {
    if (this.addWithResumesFlag) {
      this.resumeService.requestUploadResumeCancel();
      if (this.context === 'candidateScreen') {
        if (this.saveCallback) {
          this.saveCallback.emit();
        }
      }
    } else {
      let unsavedCandidatesExistFlag = false;
      this.candidatesArray.forEach((val) => {
        if (val.addStatus != 'success') {
          unsavedCandidatesExistFlag = true;
        }
      });
      if (unsavedCandidatesExistFlag && this.candidatesArray.length == 1) {
        if (this.candidatesArray[0].firstName === undefined && this.candidatesArray[0].lastName === undefined && this.candidatesArray[0].emailId === undefined && this.candidatesArray[0].phoneNumber === undefined) {
          unsavedCandidatesExistFlag = false;
        }
      }
      if (unsavedCandidatesExistFlag) {
        bootbox.confirm({
          closeButton: false,
          title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
          message: 'Are you sure you want to cancel ?<br> Unsaved data will be lost.',
          className: 'zIndex1060',
          backdrop: true,
          onEscape: false,
          buttons: {
            confirm: {
              label: 'Yes',
              className: 'btn-info'
            },
            cancel: {
              label: 'Cancel',
              className: 'btn-danger'
            }
          },
          callback: (result) => {
            if (result) {
              if (this.saveCallback) {
                this.saveCallback.emit();
              }
            } else {
              this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
          }
        });
      } else {
        if (this.saveCallback) {
          this.saveCallback.emit();
        }
      }
    }
  }

  saveCandidates() {
    const forms = this.addForms.toArray();
    const candidatesArrayForSave: any[] = [];
    let candidateAddUIErrorExists = false;
    this.candidatesArray.forEach((val, index) => {
      if (val.addStatus != 'success') {
        candidatesArrayForSave.push(_.cloneDeep(val));
        val.submitted = true;
        const form = forms[index];
        if ((form && form.invalid) || val.phoneNumberInvalid) {
          candidateAddUIErrorExists = true;
        }
      }
    });
    if (!candidateAddUIErrorExists) {
      const actualCandidatesArrayForSave = candidatesArrayForSave.map((y) => {
        delete y.submitted;
        delete y.addStatus;
        delete y.errorMessages;
        return y;
      });
      if (actualCandidatesArrayForSave.length > 0) {
        this.savingFlag = true;
        this.candidateService.addCandidates(actualCandidatesArrayForSave, (data) => {
          let allCandidatesAddedFlag = true;
          let responseArrayIndexCounter = 0;
          this.candidatesArray.forEach((val) => {
            if (val.addStatus != 'success') {
              if (data[responseArrayIndexCounter].status == 'PASSED') {
                val.addStatus = 'success';
              } else {
                allCandidatesAddedFlag = false;
                val.addStatus = 'error';
                val.errorMessages = data[responseArrayIndexCounter].messages;
              }
              responseArrayIndexCounter++;
            }
          });

          if (this.sendOutreachEmail && allCandidatesAddedFlag) {
            const passedCandidateList: any[] = [];
            if (data.length > 0) {
              data.forEach(candidate => {
                if (candidate.status === 'PASSED') {
                  passedCandidateList.push({ id: candidate.candidateDetailDto.id, candidateType: 'OWN_CANDIDATES' });
                }
              });
            }
            const outreachObject = {
              candidates: passedCandidateList,
              userId: this.userId,
              companyId: this.currentCompanyId,
              clientOrBuId: this.clientOrBuId
            };
            if (outreachObject.candidates.length > 0) {
              this.candidateService.sendOutreachEmail(outreachObject, (outreachData) => {
                this.savingFlag = false;
                this.alertsAndNotificationsService.showBannerMessage(outreachData.message, 'success');
                this.alertsAndNotificationsService.showAlertWithCallBack('Success!', 'All candidates have been added successfully!', 'success', () => {
                  if (this.saveCallback) {
                    this.saveCallback.emit();
                  }
                });
              }, (error) => {
                this.savingFlag = false;
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
              });
            } else {
              this.savingFlag = false;
            }
          } else {
            this.savingFlag = false;
            if (allCandidatesAddedFlag) {
              this.alertsAndNotificationsService.showAlertWithCallBack('Success!', 'All candidates have been added successfully!', 'success', () => {
                if (this.saveCallback) {
                  this.saveCallback.emit();
                }
              });
            }
          }
        }, (error) => {
          this.savingFlag = false;
          if (this.authService.isOnline) {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          }
        });
      }
    }
  }

  onFilesUploaded() {
    if (this.context === 'candidateScreen') {
      this.saveCallback.emit();
    }
  }

  onCandidateProcessed() {
    if (this.candidateProcessedCallback) {
      this.candidateProcessedCallback.emit();
    }
  }
}
